// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__GwNdd","error":"Textarea_error__tyonz","readonly":"Textarea_readonly__TRWFs","disabled":"Textarea_disabled__1TaGh"};